class Storage {
  constructor(type) {
    if (type === 'local') {
      this.store = window.localStorage;
    } else if (type === 'session') {
      this.store = window.sessionStorage;
    }
  }

  set(key, value) {
    try {
      value = JSON.stringify(value);
    } catch (e) {
      this.store.setItem(key, value);
      return this;
    }
    this.store.setItem(key, value);
    return this;
  }

  get(key) {
    if (!key) {
      throw new Error('没有找到key。');
    }
    if (typeof key === 'object') {
      throw new Error('key不能是一个对象。');
    }
    let value = this.store.getItem(key);

    try {
      value = JSON.parse(value);
    } catch (e) {
      return value;
    }
    return value;
  }

  remove(key) {
    this.store.removeItem(key);
    return this;
  }

  // 获取当前用户信息，仅供sessionStorage使用
  get userInfo() {
    return this.get('userInfo');
  }
  set userInfo(value) {
    this.set('userInfo', value);
  }

  // 获取当前角色信息，仅供sessionStorage使用
  get roles() {
    return this.get('roles');
  }
  set roles(value) {
    this.set('roles', value);
  }

  // 获取当前权限信息，仅供sessionStorage使用
  get popedoms() {
    return this.get('popedoms');
  }
  set popedoms(value) {
    this.set('popedoms', value);
  }

  // 获取客户端数据字典配置，仅供localStorage使用
  get dictionaryToken() {
    return this.get('dictionaryToken');
  }
  set dictionaryToken(value) {
    this.set('dictionaryToken', value);
  }
}

export const localStorage = new Storage('local');
export const sessionStorage = new Storage('session');



// WEBPACK FOOTER //
// ./src/common/util/storage.js